// extracted by mini-css-extract-plugin
export default {"container":"ContactsPage_container__LdUBF","heading":"ContactsPage_heading__ui0uF","divider":"ContactsPage_divider__vCthb"};